import { MenuBar } from '@/app/components/MenuBar';
import { ProtectedRoute } from '@/app/components/ProtectedRoute';
import React from 'react';
import { Outlet } from 'react-router-dom';

export const MainLayout: React.FC = () => (
  <ProtectedRoute>
    <div>
      <MenuBar />
      <div className="wrapper d-flex flex-column min-vh-100">
        <div className="body flex-grow-1">
          <Outlet />
        </div>
      </div>
    </div>
  </ProtectedRoute>
);
